import{jsxs as o,jsx as t}from"react/jsx-runtime";import{Link as e}from"react-router-dom";import{styled as r}from"styled-components";import{useItemName as n}from"../../../../domain/hooks/useItemName.mjs";const m=r(e)`
  margin-left: 3px;
  color: #222222;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;function i({itemName:e,path:r}){const i=n();return o("li",{children:[t("input",{type:"checkbox"}),t(m,{to:r,children:i(e)})]})}export{i as FunctionItem};
